import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { BRAND, IMAGES } from "@/lib/content";
import { Reveal } from "@/components/landing/Reveal";
import { EligibilityButton } from "@/components/landing/EligibilityButton";

export const FinalCTA = () => (
  <section
    className="relative overflow-hidden px-4 py-16 grid-bg sm:px-8 lg:py-28"
    id="inquire"
    data-testid="final-cta-section"
  >
    <div className="pointer-events-none absolute bottom-0 left-1/2 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-em1/18 blur-[120px]" />
    <div className="relative z-10 mx-auto max-w-5xl">
      {/* real classroom photos */}
      <Reveal className="mx-auto mb-12 max-w-4xl">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {[IMAGES.classroom1, IMAGES.classroom2].map((src, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
              className={`group relative overflow-hidden rounded-2xl border border-surfaceline glow-emerald ${
                i === 0 ? "sm:mt-6 sm:-rotate-1" : "sm:rotate-1"
              }`}
              data-testid={`classroom-photo-${i}`}
            >
              <img
                src={src}
                alt={`BullsEdge Academy Ahmedabad classroom session ${i + 1}`}
                style={{ objectPosition: i === 0 ? "50% 82%" : "50% 55%" }}
                className="h-72 w-full object-cover transition-transform duration-500 group-hover:scale-105 sm:h-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
              <span className="absolute bottom-3 left-3 rounded-full border border-em2/40 bg-ink/70 px-3 py-1 text-[0.7rem] font-semibold text-em2 backdrop-blur">
                Live batch · Prahladanagar, Ahmedabad
              </span>
            </motion.div>
          ))}
        </div>
      </Reveal>

      <div className="mx-auto max-w-3xl text-center">
        <Reveal>
          <h2 className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-offwhite sm:text-6xl">
            Stop Learning Alone.
            <br />
            <span className="text-em2">Come Sit in Our Classroom.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-mutedgreen sm:text-lg">
            Talk to us about our next Ahmedabad batch. We'll understand where you
            are and show you how our training — offline or with online support —
            can help.
          </p>

          <div className="mx-auto mt-9 w-full max-w-md">
            <EligibilityButton size="lg" className="w-full" testId="final-inquire-btn" />
          </div>

          <div className="mt-4 flex justify-center">
            <a
              href={BRAND.whatsapp}
              target="_blank"
              rel="noreferrer"
              data-testid="final-whatsapp-btn"
              className="inline-flex min-h-[48px] items-center gap-2 rounded-full border border-em2/40 bg-em2/10 px-6 text-sm font-semibold text-em2 transition-colors hover:bg-em2/20"
            >
              <MessageCircle size={16} /> Chat with Us on WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
